(function(angular){
	'use strict';

	angular
		.module('bigModule', [])
		.value('Big', Big);
})(window.angular);